import { Swiper, SwiperSlide } from "swiper/react";
 
import "swiper/css";
import "swiper/css/navigation";
import brandCarouselOneData from "./BrandCarouselOneData";
import BrandLogodata from "./BrandLogodata";
import { Autoplay } from "swiper";

const BrandLogos = () => {
  return (
    <div className="brand-carousel-wrapper-2 section-padding">
      <div className="container">
        <div className="row">
          <div className="col-xl-12 col-12">
            <div className="brand-carousel-active">
              <Swiper
                modules={[Autoplay]} // Enable Autoplay
                slidesPerView={4} // Show 3 slides
                spaceBetween={20} // Space between slides
                loop={true} // Enable looping
                autoplay={{
                  delay: 3000, // 3 seconds delay
                  disableOnInteraction: false, // Continue autoplay after user interaction
                }}
                breakpoints={{
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                  },
                  480: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                  },
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                  },
                }}
              >
                {BrandLogodata.map((data) => (
                  <SwiperSlide
                    className="single-brand-logo justify-content-center"
                    key={data.id}
                  >
                    <div className="IconsList">
                      <img src={data.brand} alt={data.name} />
                      <h6 style={{ color: "white" }}>{data.name}</h6>
                      <p style={{ color: "white", textAlign:"center" }}>{data.dec}</p>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandLogos;
